<template>
	<div>

		<h5>Subscribe our newsletter</h5>
        <form  method="POST" action="" v-on:submit.prevent="subscribe">
        	<span v-if="newsletter_error" class="subscribe-error">{{ newsletter_error }}</span>
        	<span v-if="newsletter_success" class="subscribe-success">Subscribed successfully</span>
        	<input type="email" v-model="newsletter_email" name="newsletter_email" placeholder="Enter your email address" class="form-control" v-bind:class="{required:newsletter_email_error}">
        	<input type="submit" v-if="!newsletter_loading" name="submit" class="subscribe_btn" value="Subscribe Now">
            <input type="submit" v-if="newsletter_loading" name="submit" class="subscribe_btn" value="Wait..." disabled>
        </form>
    </div>
</template>
<script>
	import axios from 'axios';
	export default {
		data() {
            return {
                newsletter_email:'',
                newsletter_email_error:false,
                newsletter_loading:false,
                newsletter_error:null,
                newsletter_success:false,
            }
        },
        methods:{
            subscribe(){
            	var _self = this;
            	if(_self.newsletter_email==""){
            		_self.newsletter_email_error = true;
            		return false;
            	}
            	_self.newsletter_email_error = false;
            	_self.newsletter_loading = true;
            	axios.post(_self.$hostname+'/api/email_subscribe',
	            {
	              email:_self.newsletter_email,
	            })
	            .then((res) => {
	            	_self.newsletter_email = '';
	            	_self.newsletter_loading = _self.newsletter_error = false;
                	_self.newsletter_success = true;
	            })
	            .catch((error) => {
	            	_self.newsletter_loading = _self.newsletter_success = false;
	            	_self.newsletter_email_error = true;
	            	_self.newsletter_error = error.response.data.email[0];
	                return false;  
	            })   
            }
        }
	}
</script>


// WEBPACK FOOTER //
// src/components/NewsletterForm.vue